// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-cards{display:grid;grid-template-columns:repeat(2,1fr);grid-gap:16px}@media (max-width:991px){.logo-cards{grid-template-columns:auto;grid-gap:8px}}", ""]);
// Exports
module.exports = exports;
